// core
import React from 'react';
import { useSelector } from 'react-redux';
import { defineMessages, FormattedMessage } from 'react-intl';

// UI
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import { selectLayout } from '../../../state';

const messages = defineMessages({
  APPLY_FILTERS_TITLE: {
    id: 'APPLY_FILTERS_TITLE',
    defaultMessage: 'Override current filters?',
  },
  APPLY_FILTERS_MSG: {
    id: 'APPLY_FILTERS_MSG',
    defaultMessage: 'You made changes to the default filters. Would you like to override filters on existing cards?',
  },
  OVERRIDE: {
    id: 'OVERRIDE',
    defaultMessage: 'Override',
  },
  IGNORE: {
    id: 'IGNORE',
    defaultMessage: 'Ignore',
  },
});

function FilterOverrideDialog({ applySave, applyFiltersToCardsAndSave }) {
  const layout = useSelector(selectLayout);

  return (
    <Dialog
      open={layout.showFilterOverrideDialog || false}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        <FormattedMessage {...messages.APPLY_FILTERS_TITLE} />
      </DialogTitle>

      <DialogContent>
        <DialogContentText>
          <FormattedMessage {...messages.APPLY_FILTERS_MSG} />
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button onClick={applySave} color="primary">
          <FormattedMessage {...messages.IGNORE} />
        </Button>

        <Button onClick={applyFiltersToCardsAndSave} color="primary" autoFocus>
          <FormattedMessage {...messages.OVERRIDE} />
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default FilterOverrideDialog;
